module.exports = __webpack_public_path__ + "img/nightprofile.5d34c440.jpg";